import React, { useEffect, useState } from 'react'
import IconsTextNavigation from 'components/global/IconsTextNavigation'
import SecurityModal from 'pages/Events/Views/Common/Modals/SecurityModal'
import { creationEventStore } from 'state/event/eventCreationStore'

const Security: React.FC = () => {
  const [openSecurityModal, setOpenSecurityModal] = useState<boolean>(false)
  const { riskLevel, setRiskLevel, eventData } = creationEventStore(store => ({
    riskLevel: store.riskLevel,
    setRiskLevel: store.setRiskLevel,
    eventData: store.eventData,
  }))

  useEffect(() => {
    setRiskLevel(eventData.riskLevel)
  }, [])

  return (
    <>
      <div onClick={() => setOpenSecurityModal(true)}>
        <IconsTextNavigation
          iconName="ShieldCheck"
          heading="Security"
          isCompleted={riskLevel}
        />
      </div>
      {openSecurityModal && (
        <SecurityModal
          openModal={openSecurityModal}
          closeModal={setOpenSecurityModal}
          riskLevel={riskLevel}
          setRiskLevel={setRiskLevel}
        />
      )}
    </>
  )
}

export default Security
